import { Types } from '@store/types';

const initialState = [];

const FabricReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_FABRIC_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default FabricReducer;
